<template>
  <FieldBox :title="$t('trade.position')" class="order-positon">
    <RadioBox v-model="position" :options="options" />
  </FieldBox>
</template>

<script>
import { MARKET_TYPE } from 'const/stock'
import { mapGetters } from 'vuex'
import FieldBox from '../FieldBox'
import RadioBox from '../RadioBox'
import getFixedPriceWithMinTick from 'utils/getFixedPriceWithMinTick'
export default {
  name: 'Positon',
  components: {
    FieldBox,
    RadioBox
  },
  props: {
    maxQuantity: Number,
    positionNum: Number,
    isLeveraged: Boolean
  },
  watch: {},
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    stock() {
      return this.tradeRequest.stock
    },
    position: {
      get() {
        return this.order.quickPosition
      },
      set(position) {
        const posQuantity = Math.floor(this.maxQuantity / (position + 1))
        const lotSize = this.stock.lotSize || 1
        this.$store.dispatch('updateTradeOrder', {
          quickPosition: position, // 快捷仓位设置
          totalQuantity: this.isHK
            ? getFixedPriceWithMinTick(posQuantity, lotSize)
            : posQuantity
        })
      }
    },
    options() {
      return [
        // 全仓
        { label: this.$t('trade.full-position'), value: 0 },
        // 半仓
        { label: this.$t('trade.half-position'), value: 1 },
        // 三分之一
        { label: this.$t('trade.one-third-position'), value: 2 },
        // 四分之一
        { label: this.$t('trade.quarter-position'), value: 3 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.positon {
  display: flex;
  label {
    min-width: 100px;
    text-align: left;
    padding: 10px;
  }
  .variety {
    margin-top: 3px;
    width: 200px;
    flex: 0 0;
  }
}
</style>
